const i18nextKeys = {
  commonEnabled: 'common.enabled',
  commonDisabled: 'common.disabled',
  commonYes: 'common.yes',
  commonNo: 'common.no',
  commonShowMore: 'common.showMore',
  commonShowLess: 'common.showLess',
  commonReadMore: 'common.readMore',
  commonReadLess: 'common.readLess',
  commonProceed: 'common.proceed',
  commonClearSelection: 'common.clearSelection',
  commonTotal: 'common.total',
  commonMax: 'common.max',
  commonDate: 'common.date',
  commonReferenceCode: 'common.referenceCode',
  commonOrderId: 'common.orderId',
  commonCurrency: "common.currency",
  commonCryptocurrency: 'common.cryptocurrency',
  commonCryptocurrencies: 'common.cryptocurrencies',
  commonCreditCard: 'common.creditCard',
  commonAdditionalData: 'common.additionalData',
  commonSparks: 'common.sparks',
  commonUnits: 'common.units',
  commonEnvironment: "common.environment",
  commonSandbox: "common.sandbox",
  commonProduction: "common.production",
  commonVersion: "common.version",
  commonTemplate: "common.template",
  commonTerms: "common.terms",

  commonInfoUser: "common.info.user",
  commonInfoPersonal: 'common.info.personal',
  commonFirstName: "common.firstName",
  commonLastName: "common.lastName",
  commonBirthDate: "common.birthDate",
  commonPhoneNumber: "common.phoneNumber",
  commonEmail: "common.email",
  commonNationality: "common.nationality",

  commonAddressPersonal: 'common.address.personal',
  commonAddressShipping: 'common.address.shipping',
  commonAddressInvoice: 'common.address.invoice',
  commonAddressStreet: "common.address.street",
  commonAddressZip: "common.address.zip",
  commonAddressCity: "common.address.city",
  commonAddressRegion: "common.address.region",
  commonAddressCountry: "common.address.country",
  
  commonBankTransfer: 'common.bank.transfer',
  commonBankAccount: 'common.bank.account',
  commonBankAccountDetails: "common.bank.accountDetails",
  commonBankAddress: "common.bank.address",
  commonBankName: "common.bank.name",
  commonBankIban: "common.bank.iban",
  commonBankSwift: "common.bank.swift",
  commonBankBic: "common.bank.bic",
  commonBankBeneficiaryAccount: 'common.bank.beneficiary.account',
  commonBankBeneficiaryAddress: "common.bank.beneficiary.address",
  commonBankBeneficiaryName: "common.bank.beneficiary.name",
  commonBankBeneficiarySwift: "common.bank.beneficiary.swift",
  commonBankBeneficiaryBic: "common.bank.beneficiary.bic",
  commonBankAdditionalDetails: "common.bank.additionalDetails",
  commonBankAdditionalDetailsPlaceholder: "common.bank.additionalDetails.placeholder",
  commonBankIntermediaryAdd: "common.bank.intermediary.add",
  commonBankIntermediaryDelete: "common.bank.intermediary.delete",
  commonBankIntermediaryDetails: 'common.bank.intermediary.details',
  commonBankIntermediaryAccount: "common.bank.intermediary.account",
  commonBankIntermediaryAccountDetails: "common.bank.intermediary.accountDetails",
  commonBankIntermediaryAddress: "common.bank.intermediary.address",
  commonBankIntermediaryName: "common.bank.intermediary.name",
  commonBankIntermediaryIban: "common.bank.intermediary.iban",
  commonBankIntermediarySwift: "common.bank.intermediary.swift",

  commonWalletDetails: "common.wallet.details",
  commonWalletCrypto: 'common.wallet.crypto',
  commonWalletName: 'common.wallet.name',
  commonWalletAddress: 'common.wallet.address',
  commonWalletEthereumAddress: 'common.wallet.ethereumAddress',
  commonWalletSave: "common.wallet.save",
  commonWalletNetwork: "common.wallet.network",

  commonFee: "common.fee",
  commonFeeMethod: "common.fee.method",
  commonFeeCountry: "common.fee.country",
  commonFeeFixed: "common.fee.fixed",
  commonFeeVariable: "common.fee.variable",
  commonFeeTotal: "common.fee.total",
  commonFeePercentage: "common.fee.percentage",

  commonConfigTooltip: "admin:common.config.tooltip",

  commonKycTier: 'common.kyc.tier',

  commonErrorInvalidQuantity: 'common.error.invalidQuantity',
  commonErrorNoData: 'common.error.noData',

  accountHeader: 'account.header',
  accountGetLanguageError: 'account.getLanguageError',
  accountSetLanguageError: 'account.setLanguageError',

  accountBankAccountsHeading: 'account.bankAccounts.heading',
  accountBankAccountsDeletionHeading: 'account.bankAccounts.deletion.heading',
  accountBankAccountsDeletionText: 'account.bankAccounts.deletion.text',

  accountWalletsHeading: 'account.wallets.heading',
  accountWalletsDeletionHeading: 'account.wallets.deletion.heading',
  accountWalletsDeletionText: 'account.wallets.deletion.text',

  buttonOk: 'button.ok',
  buttonBack: 'button.back',
  buttonLogout: 'button.logout',
  buttonHome: 'button.home',
  buttonConfirm: 'button.confirm',
  buttonConfirmAndSubmit: 'button.confirmAndSubmit',
  buttonCancel: 'button.cancel',
  buttonRemove: 'button.remove',
  buttonReject: 'button.reject',
  buttonDelete: 'button.delete',
  buttonDecline: 'button.decline',
  buttonAccept: 'button.accept',
  buttonApprove: 'button.approve',
  buttonSave: 'button.save',
  buttonSaveChanges: 'button.saveChanges',
  buttonManageCredentials: 'button.manageCredentials',
  buttonOrderHistory: 'button.orderHistory',
  buttonRedemptionHistory: 'button.redemptionHistory',
  buttonStartKyc: 'button.startKyc',
  buttonUpgradeKyc: 'button.upgradeKyc',
  buttonAddWallet: 'button.addWallet',
  buttonPassportScan: 'button.passportScan',
  buttonSelfie: 'button.selfie',
  buttonUtilityBill: 'button.utilityBill',
  buttonSubmit: 'button.submit',
  buttonValidate: 'button.validate',
  buttonCloseThisCase: 'button.closeThisCase',
  buttonReopenThisCase: 'button.reopenThisCase',
  buttonExport: 'button.export',
  buttonEdit: 'button.edit',
  buttonSend: 'button.send',
  buttonResend: 'button.resend',
  buttonReplace: 'button.replace',
  buttonCheckout: 'button.checkout',
  buttonContinue: 'button.continue',
  buttonConfirmAndContinue: 'button.confirmAndContinue',
  buttonSelectThisMethod: 'button.selectThisMethod',
  buttonSelectAndContinue: 'button.selectAndContinue',
  buttonClose: 'button.close',
  buttonMoreDetails: 'button.moreDetails',
  buttonAddToCart: 'button.addToCart',
  buttonLoginToBuy: 'button.loginToBuy',
  buttonMoreInfo: 'button.moreInfo',
  buttonAbort: 'button.abort',
  buttonSkip: 'button.skip',
  buttonAdd: 'button.add',
  buttonPromoteToAdmin: 'button.promoteToAdmin',
  buttonTurnOff: 'button.turnOff',
  buttonTurnOn: 'button.turnOn',
  buttonNotAvailable: 'button.notAvailable',

  inputNoResultsFound: "input.noResultsFound",

  cardsUserEditPersonalInfo: 'cards.user.editPersonalInfo',
  cardsBankAccountsNoBankAccountStored:
    'cards.bankAccounts.noBankAccountStored',
  cardsBankAccountsFormHeaderAdd: 'cards.bankAccounts.form.headerAdd',
  cardsBankAccountsFormHeaderEdit: 'cards.bankAccounts.form.headerEdit',
  cardsBankAccountsFormAddBankAccount: 'cards.bankAccounts.form.addBankAccount',
  cardsKycDetailsFormAddressLine: 'cards.kycDetails.form.addressLine',
  cardsKycDetailsFormState: 'cards.kycDetails.form.state',
  cardsKycCurrentTierHeader: 'cards.kyc.currentTier.header',
  cardsKycCurrentTierDescription: 'cards.kyc.currentTier.description',
  cardsKycLastCheckHeader: 'cards.kyc.lastCheck.header',
  cardsKycLastCheckDescription: 'cards.kyc.lastCheck.description',
  cardsKycDeclinedReason: 'cards.kyc.declined.reason',
  cardsKycDeclinedOpenReasonModal: 'cards.kyc.declined.openReasonModal',
  cardsKycDeclinedReasonModalHeader: 'cards.kyc.declined.reasonModalHeader',
  cardsWalletTypeNoWalletsStored: 'cards.walletType.noWalletsStored',
  cardsWalletType: 'cards.wallet.type',
  cardsWalletFormHeaderAdd: 'cards.wallet.form.headerAdd',
  cardsWalletFormHeaderEdit: 'cards.wallet.form.headerEdit',

  cartHeader: 'cart.header',
  cartTotalAmount: 'cart.totalAmount',
  cartTableHeaderItem: 'cart.tableHeader.item',
  cartTableHeaderPrice: 'cart.tableHeader.price',
  cartTableHeaderQuantity: 'cart.tableHeader.quantity',
  cartTableHeaderTotal: 'cart.tableHeader.total',
  cartTableLearnMore: 'cart.table.learnMore',
  cartTableHideItems: "cart.table.hideItems",
  cartTableShowItems: "cart.table.showItems",
  cartAutoRemovedItems: 'cart.autoRemoved.items',
  cartBadgeMaxQuantity: 'cart.badge.maxQuantity',
  cartBadgeSoldOut: 'cart.badge.soldOut',
  cartMessageRounded: "cart.message.rounded",
  cartMessageFees: "cart.message.fees",

  checkoutCompletionHeader: 'checkout.completion.header',
  checkoutCompletionAddressTokenCard: 'checkout.completion.address.tokenCard',
  checkoutCompletionAddressWallet: 'checkout.completion.address.wallet',
  checkoutCompletionTokenCardEnsureDeposit: 'checkout.completion.tokenCard.ensureDeposit',
  checkoutFinishButton: "checkout.finish.button",

  checkoutFeeMethod: 'checkout.fee.method',
  checkoutFeeMethodDescription: "checkout.fee.method.description",
  checkoutFeeCountryDescription: "checkout.fee.country.description",
  checkoutFeeTotal: 'checkout.fee.total',

  checkoutCustomerDetailsPurpose: 'checkout.customerDetails.purpose',
  checkoutCustomerDetailsFormInvoiceInfo:
    'checkout.customerDetails.form.invoiceInfo',
  checkoutBankBeneficiary: 'checkout.bank.beneficiary',
  checkoutOrderWarning: 'checkout.order.warning',
  checkoutPaymentMethodsBankDetailsIntermediaryAccount:
    'checkout.payment.methods.bankDetails.intermediary.account',
  checkoutPaymentMethodsBankDetailsAmountAndReference:
    'checkout.payment.methods.bankDetails.amountAndReference',
  checkoutPaymentMethodsBankDetailsAmount:
    'checkout.payment.methods.bankDetails.amount',
  checkoutPaymentMethodsBankDetailsPaymentReference:
    'checkout.payment.methods.bankDetails.paymentReference',
  checkoutPaymentMethodsBankTransferTransferToBeneficiary:
    'checkout.payment.methods.bankTransfer.transferToBeneficiary',
  checkoutPaymentMethodsBankTransferClickToCopy:
    'checkout.payment.methods.bankTransfer.clickToCopy',
  checkoutPaymentMethodSelect: 'checkout.payment.method.select',
  checkoutPaymentMethodLimit: 'checkout.payment.method.limit',
  checkoutPaymentWarning: 'checkout.payment.warning',
  checkoutCollectionMethodSelect: 'collectionMethod.methodSelect',
  collectionMethodDetailsHeader: 'collectionMethod.details.header',
  collectionMethodDetailsHeaderSmallScreen: 'collectionMethod.details.header.smallScreen',
  collectionMethodDetailsEthAddress: 'collectionMethod.details.ethAddress',
  collectionMethodDetailsDescriptionSmallScreen: 'collectionMethod.details.description.smallScreen',
  collectionTitle: 'collection.title',
  collectionDescription: 'collection.description',
  collectionTokenCardModalTitle: "collection.tokenCard.modal.title",
  collectionTokenCardModalLabel: "collection.tokenCard.modal.label",
  collectionTokenCardModalError: "collection.tokenCard.modal.error",
  collectionFee: "collection.fee",
  collectionOneTimeWalletTitle: "collection.oneTimeWallet.title",
  collectionOneTimeWalletDescription: "collection.oneTimeWallet.description",
  collectionMethodInputOneTimeAddress: 'collectionMethod.inputOneTimeAddress',
  collectionMethodInputOneTimeAddressFormat: 'collectionMethod.inputOneTimeAddress.format',
  collectionMethodInputOneTimeAddressSampleAddress: 'collectionMethod.inputOneTimeAddress.sampleAddress',
  collectionMethodInputOneTimeAddressNameLabel: 'collectionMethod.inputOneTimeAddress.nameLabel',
  checkoutHeaderNavigationSelectWallet:
    'checkout.headerNavigation.selectWallet',
  checkoutHeaderNavigationDetails: 'checkout.headerNavigation.details',
  checkoutHeaderNavigationYourOrder: 'checkout.headerNavigation.yourOrder',
  checkoutHeaderNavigationPayment: 'checkout.headerNavigation.payment',
  checkoutHeader: 'checkout.header',
  checkoutTimerDraftOrderMessage: 'checkout.timer.draftOrderMessage',
  checkoutTimerBankTransferMessage: 'checkout.timer.bankTransferMessage',
  checkoutTimeExpiredPrimaryMessage: 'checkout.timeExpired.primaryMessage',
  checkoutTimeExpiredSecondaryMessage: 'checkout.timeExpired.secondaryMessage',
  checkoutTimeExpiredGoBack: 'checkout.timeExpired.GoBack',

  copiedToClipboardInfo: 'copiedToClipboard.info',

  cookieNoticeDescription: 'cookieNotice.description',
  cookieNoticeSettings: 'cookieNotice.settings',
  cookieModalAlwaysEnabled: 'cookieModal.alwaysEnabled',
  cookieModalDescription: 'cookieModal.description',
  cookieModalNecessaryCookieTitle: 'cookieModal.necessaryCookie.title',
  cookieModalNonNecessaryCookieTitle: 'cookieModal.nonNecessaryCookie.title',
  cookieModalNecessaryCookieDescription:
    'cookieModal.necessaryCookie.description',
  cookieModalNonNecessaryCookieDescription:
    'cookieModal.nonNecessaryCookie.description',
  cookieModalFooterDescription: 'cookieModal.footer.description',

  enumCollectMethodTokenCardName: 'enum.collectMethod.tokenCard',
  enumCollectMethodOwnWalletName: 'enum.collectMethod.ownWallet',
  enumCollectMethodOwnWalletNsName: 'enum.collectMethod.ownWallet.ns',
  enumOrderStatusPaymentError: 'enum.orderStatus.paymentError',
  enumOrderStatusPaymentTimeout: 'enum.orderStatus.paymentTimeout',
  enumOrderStatusSendingError: 'enum.orderStatus.sendingError',
  enumOrderStatusWaitingForPayment: 'enum.orderStatus.waitingForPayment',
  enumOrderStatusDraft: 'enum.orderStatus.draft',
  enumOrderStatusAborted: 'enum.orderStatus.aborted',
  enumOrderStatusReceived: 'enum.orderStatus.received',
  enumOrderStatusSent: 'enum.orderStatus.sent',
  enumOrderStatusError: 'enum.orderStatus.error',
  enumInvalidEnum: 'enum.invalidEnum',
  enumNone: 'enum.none',
  enumRedemptionStatusDraft: 'enum.redemptionStatus.draft',
  enumRedemptionStatusPaymentTimeout: 'enum.redemptionStatus.paymentTimeout',
  enumRedemptionStatusNew:
    'enum.redemptionStatus.new',
  enumRedemptionStatusProcessing: 'enum.redemptionStatus.processing',
  enumRedemptionStatusPayoutError: 'enum.redemptionStatus.payoutError',
  enumRedemptionStatusReceived: 'enum.redemptionStatus.received',
  enumRedemptionStatusPaid: 'enum.redemptionStatus.paid',
  enumRedemptionStatusAborted: 'enum.redemptionStatus.aborted',
  enumRedemptionStatusError: 'enum.redemptionStatus.error',

  enumTransactionStatusNotInitiated: 'enum.transactionStatus.notInitiated',
  enumTransactionStatusReceived: 'enum.transactionStatus.received',
  enumTransactionStatusSubmitted: 'enum.transactionStatus.submitted',
  enumTransactionStatusCommitted: 'enum.transactionStatus.committed',
  enumTransactionStatusConfirmed: 'enum.transactionStatus.confirmed',
  enumTransactionStatusRevokedByBlockchain:
    'enum.transactionStatus.revokedByBlockchain',
  enumTransactionStatusRejectedByUser: 'enum.transactionStatus.rejectedByUser',
  enumTransactionStatusFailed: 'enum.transactionStatus.failed',

  errorConfirmationRequired: 'error.confirmationRequired',
  errorAdditionalData: 'error.additionalData',
  errorMessageLoadEnvSettings: 'error.message.loadEnvSettings',
  errorMessageAuthProcessFail: 'error.message.authProcessFail',
  errorMessageLoadConfig: 'error.message.load',
  errorMessageLoadStylesheetFavicon: 'error.message.loadStylesheetFavicon',
  errorMessageFillOutThisField: 'error.message.fillOutThisField',
  errorSignup: 'error.signup',
  errorBankAccountsCardsStoreBankAccount:
    'error.bankAccountsCards.storeBankAccount',
  errorBankAccountsCardsDeleteBankAccount:
    'error.bankAccountsCards.deleteBankAccount',
  errorKycDetailsCardsSubmission: 'error.kycDetailsCards.submission',
  errorKycDetailsTableLoading: 'error.kycDetailsTable.loading',
  errorProfileCardAvatarToManySelectedFiles:
    'error.profileCard.avatar.toManySelectedFiles',
  errorProfileCardAvatarSelectOnlyOneFile:
    'error.profileCard.avatar.selectOnlyOneFile',
  errorProfileCardAvatarInvalidFileType:
    'error.profileCard.avatar.invalidFileType',
  errorProfileCardAvatarSelectFileType:
    'error.profileCard.avatar.selectFileType',
  errorProfileCardAvatarFileSizeTooLarge:
    'error.profileCard.avatar.fileSizeTooLarge',
  errorProfileCardAvatarSelectFileSize:
    'error.profileCard.avatar.selectFileSize',
  errorProfileCardAvatarCouldNotRemove:
    'error.profileCard.avatar.couldNotRemove',
  errorProfileCardNoCredentials: 'error.profileCard.noCredentials',
  errorProfileCardNoUpdateProfileImage:
    'error.profileCard.noUpdateProfileImage',
  errorWalletCardAddWalletAlreadyConnected:
    'error.walletCard.addWallet.alreadyConnected',
  errorWalletCardAddWalletCouldNotSave:
    'error.walletCard.addWallet.couldNotSave',
  errorWalletCardDeleteWalletCouldNotDelete:
    'error.walletCard.deleteWallet.couldNotDelete',
  errorKycProcessProvideAllFiles: 'error.kyc.process.provideAllFiles',
  errorKycCreateCase: 'error.kyc.createCase',
  errorOrderHistoryNoRequiredData: 'error.orderHistory.noRequiredData',
  errorRedeemHistoryNoRequiredData: 'error.redeemHistory.noRequiredData',
  errorAccountNoRequiredData: 'error.account.noRequiredData',
  errorConfigManagementCouldNotParseLoadConfig:
    'error.configManagement.couldNotParseLoadConfig',
  errorConfigManagementInvalidJson: 'error.configManagement.invalidJson',
  errorConfigManagementSaveConfigFail: 'error.configManagement.saveConfigFail',
  errorKycManagementCouldNotUpdateKycLevel:
    'error.kycManagement.couldNotUpdateKycLevel',
  errorKycManagementDetailsLoadError: 'error.kycManagement.details.loadError',
  errorKycManagementDetailsUpdateRecordStatusError:
    'error.kycManagement.details.updateRecordStatusError',
  errorKycManagementOverviewLoadingError:
    'error.kycManagement.overview.loadingError',
  errorKycManagementOverviewExportError:
    'error.kycManagement.overview.exportError',
  errorPurchaseManagementDetailsDownloadInvoiceFail:
    'error.purchaseManagement.details.downloadInvoiceFail',
  errorPurchaseManagementDetailsOrderStatusUpdateError:
    'error.purchaseManagement.details.orderStatus.updateError',
  errorPurchaseManagementDetailsLoadingError:
    'error.purchaseManagement.details.loadingError',
  errorPurchaseManagementDetailsSendingFailure:
    'error.purchaseManagement.details.sendingFailure',
  errorPurchaseManagementDetailsWalletAddressNotUpdated:
    'error.purchaseManagement.details.walletAddressNotUpdated',
  errorPurchaseManagementOverviewLoadingError:
    'error.purchaseManagement.overview.loadingError',
  errorPurchaseManagementOverviewExportRecordsFail:
    'error.purchaseManagement.overview.exportRecordsFail',
  errorRedeemManagementDetailsLoadingError:
    'error.redeemManagement.details.loadingError',
  errorRedeemManagementDetailsNoRedemptionStatusUpdate:
    'error.redeemManagement.details.noRedemptionStatusUpdate',
  errorRedeemManagementRedeemRecordsExportFailure:
    'error.redeemManagement.redeemRecordsExportFailure',
  errorCartAssetsLoadingError: 'error.cart.assetsLoadingError',
  errorCartAssetsLoadingErrorWithMessage:
    'error.cart.assetsLoadingErrorWithMessage',
  errorCartCustomerDetailsLoadingError:
    'error.cart.customerDetails.loadingError',
  errorOrderCreate: "error.order.create",
  errorCartCheckoutPaymentProviderLaunchError:
    'error.cart.checkout.payment.providerLaunchError',
  errorCartCheckoutPaymentUpdateStatusError:
    'error.cart.checkout.payment.updateStatusError',
  errorCartCheckoutPaymentOrderUnsuccessful:
    'error.cart.checkout.payment.orderUnsuccessful',
  errorCartcollectionMethodRetrievingAddressFailure:
    'error.cart.collectionMethod.retrievingAddressFailure',
  errorPurchaseAssetLoadingError: 'error.purchase.assetLoadingError',
  errorRedemptionDetailsPdf: 'error.redemption.details.pdf',
  errorRedeemDetailsUserDataRetrievingError:
    'error.redeem.details.userDataRetrievingError',
  errorRedeemDetailsRedemptionCreationFailure:
    'error.redeem.details.redemptionCreationFailure',
  errorRedeemSummaryRedemptionCreationFailure:
    'error.redeem.summary.redemptionCreationFailure',
  errorDefaultMessage: 'error.defaultMessage',
  errorToastError: 'error.toastError',
  errorToastErrorFinalNote: 'error.toastError.finalNote',
  errorToastErrorClickMessage: 'error.toastError.clickMessage',
  errorStatesCartLoadCartError: 'error.states.cart.loadCartError',
  errorStatesCartAddItemToCartError: 'error.states.cart.addItemToCartError',
  errorStatesCartRemoveItemToCartError:
    'error.states.cart.removeItemToCartError',
  errorStatesCartEmptyCartError: 'error.states.cart.emptyCartError',
  errorStatesCartSetQuantityError: 'error.states.cart.setQuantityError',

  errorPageHeader: 'errorPage.header',
  errorPageNotFoundHeading: 'errorPage.notFound.heading',
  errorPageNotFoundText: 'errorPage.notFound.text',
  errorPageServerProblemHeading: 'errorPage.serverProblem.heading',
  errorPageServerProblemText: 'errorPage.serverProblem.text',
  errorPageServiceUnavailableHeading: 'errorPage.serviceUnavailable.heading',
  errorPageServiceUnavailableText: 'errorPage.serviceUnavailable.text',
  errorPageAccessDeniedHeading: 'errorPage.accessDenied.heading',
  errorPageAccessDeniedText: 'errorPage.accessDenied.text',
  errorPageTryAgain: 'errorPage.tryAgain',

  helperOrderUser: 'helper.order.user',
  helperOrderBilled: 'helper.order.billed',
  helperOrderCollectedVia: 'helper.order.collectedVia',
  helperOrderPayVia: 'helper.order.payVia',
  helperOrderStatus: 'helper.order.status',
  helperRedeemId: 'helper.redeem.id',
  helperRedeemUser: 'helper.redeem.user',
  helperRedeemMethod: 'helper.redeem.method',
  helperRedeemStatus: 'helper.redeem.status',
  helperValidatorArray: 'helper.validator.array',
  helperValidatorArrayEmpty: "helper.validator.array.empty",
  helperValidatorObject: 'helper.validator.object',
  helperValidatorJson: 'helper.validator.json',
  helperValidatorString: 'helper.validator.string',
  helperValidatorEmptyString: 'helper.validator.emptyString',
  helperValidatorStringDigits: 'helper.validator.stringDigits',
  helperValidatorHexString: 'helper.validator.hexString',
  helperValidatorLowerBoundAndUpperBound:
    'helper.validator.lowerBoundAndUpperBound',
  helperValidatorNumber: 'helper.validator.number',
  helperValidatorPositiveNumber: 'helper.validator.positiveNumber',
  helperValidatorNonNegativeInteger: 'helper.validator.nonNegativeInteger',
  helperValidatorNonNegativeNumber: 'helper.validator.nonNegativeNumber',
  helperValidatorNumberNumericString: 'helper.validator.numberNumericString',
  helperValidatorLength: 'helper.validator.length',
  helperValidatorDecimalPlaces: 'helper.validator.decimalPlaces',

  imprintHeader: 'imprint.header',
  imprintCompany: 'imprint.company',
  imprintAddress: 'imprint.address',
  imprintPhone: 'imprint.phone',
  imprintEmail: 'imprint.email',

  about: "about",
  aboutTitle: "about.title",
  aboutCopyButton: "about.copy.button",
  aboutCopyNotification: "about.copy.notification",
  aboutTerms: "about.terms",
  aboutDp: "about.dp",

  kycTiersPageHeader: 'kyc.tiers.pageHeader',
  kycGuideStep1: 'kyc.guide.step.1',
  kycGuideStep2: 'kyc.guide.step.2',
  kycGuideStep2Manual: 'kyc.guide.step.2.manual',
  kycTiersGuideCheckTierStatus: 'kyc.guide.step.3',
  kycTiersGuideUseUnlockedFeatures: 'kyc.guide.step.4',
  kycTiersHeader: 'kyc.tiers.header',
  kycTiersAvailabilityPurchase: 'kyc.tiers.availability.purchase',
  kycTiersAvailabilityRedemption: 'kyc.tiers.availability.redemption',
  kycTiersPaymentMethodBankTransfer: 'kyc.tiers.paymentMethod.bankTransfer',
  kycTiersPaymentMethodCreditCard: 'kyc.tiers.paymentMethod.creditCard',
  kycTiersPaymentMethodCryptoCurrency:
    'kyc.tiers.paymentMethod.cryptocurrency',
  kycTiersPaymentMethodTemplate: 'kyc.tiers.paymentMethodTemplate',
  kycTiersRedemptionTemplate: 'kyc.tiers.redemptionTemplate',
  kycTierUpgrade: 'kyc.tierUpgrade',
  kycGetTier: 'kyc.getTier',
  kycProcessing: 'kyc.processing',
  kycProcessingMessage: 'kyc.processingMessage',
  kycGetTierToSelect: 'kyc.getTierToSelect',
  kycGetTierToContinue: 'kyc.getTierToContinue',
  kycGetTierToBuy: 'kyc.getTierToBuy',
  kycLoadUserTierError: 'kyc.loadUserTierError',
  kycPoviderRedirectonModalHeading: 'kyc.providerRedirectonModal.heading',
  kycPoviderRedirectonModalText: 'kyc.providerRedirectionModal.text',
  kycManualConfirmationHeading: "kyc.manual.confirmation.heading",
  kycManualConfirmationText: "kyc.manual.confirmation.text",

  kycLevelInfoBoxNotVerified: 'kyc.level.infoBox.notVerified',
  kycLevelInfoBoxTier: 'kyc.level.infoBox.tier',
  kycCaseStatusOpen: 'kyc.case.status.open',
  kycCaseStatusDeclined: 'kyc.case.status.declined',
  kycCaseStatusApproved: 'kyc.case.status.approved',
  kycCaseTooltipApprove: 'kyc.case.tooltip.approve',
  kycCaseTooltipDecline: 'kyc.case.tooltip.decline',

  modalEscape: 'modal.escape',

  orderHistoryHeader: 'orderHistory.header',

  purchaseAssetCardPriceTag: 'purchase.assetCard.priceTag',

  addToCartMaxQuantity: 'addToCart.maxQuantity',
  addToCartNotAvailable: 'addToCart.notAvailable',
  addToCartMaxQuantityInCart: 'addToCart.maxQuantityInCart',
  addToCartRounded: "addToCart.rounded",
  addToCartLoading: "addToCart.loading",
  addToCartIsInTheCartUOM: 'addToCart.isInTheCartUOM',
  addToCartAreInTheCartUOM: 'addToCart.areInTheCartUOM',
  addToCartIsInTheCart: 'addToCart.isInTheCart',
  addToCartAreInTheCart: 'addToCart.areInTheCart',

  redeemFinishTitle: 'redeem.finish.title',
  redeemFinishSubtitle: 'redeem.finish.subtitle',
  redeemFinishDescription: 'redeem.finish.description',
  redeemFinishRedemptionReferenceCode: 'redeem.finish.redemptionReferenceCode',
  redeemFinishPaymentDetails: 'redeem.finish.paymentDetails',
  redeemFinishPaymentGross: 'redeem.finish.grossPay',
  redeemFinishPaymentNet: 'redeem.finish.netPay',
  redeemFinishPaymentAsset: 'redeem.finish.assetPay',
  redeemFinishPayoutDetails: 'redeem.finish.payoutDetails',
  redeemFinishAmountReceive: 'redeem.finish.amountReceive',
  redemptionFinishButton: "redemption.finish.button",

  redeemErrorTitle: 'redeem.error.title',
  redeemErrorDescription: 'redeem.error.description',
  redeemErrorStartOver: 'redeem.error.startOver',
  redeemMethodSelectionPayWith: 'redeem.methodSelection.payWith',
  redeemQrInfo: 'redeem.qr.info',
  redeemQrDescription: 'redeem.qr.description',
  redeemQrInstructions: 'redeem.qr.instructions',
  redeemQrCopy: 'redeem.qr.copy',
  redeemQrData: 'redeem.qr.data',
  redeemTransferInfo: 'redeem.transfer.info',
  redeemTransferDescription: 'redeem.transfer.description',
  redeemSummaryBankBankAddressCity: 'redeem.summary.bank.bankAddressCity',
  redeemSummaryBankBankAddressZip: 'redeem.summary.bank.bankAddressZip',
  redemptionSummaryHeader: 'redemption.summary.header',
  redeemHeaderNavigationSelectMethod: 'redeem.headerNavigation.selectMethod',
  redeemHeaderNavigationDetails: 'redeem.headerNavigation.details',
  redeemHeaderNavigationSummary: 'redeem.headerNavigation.summary',
  redeemHeaderNavigationFinish: 'redeem.headerNavigation.finish',

  orderCheckSentInvoice: 'order.checkSentInvoice',
  orderTotal: 'order.total',
  orderDetails: 'order.details',
  orderInformation: 'order.information',
  orderInvoiceInformation: 'order.invoiceInformation',
  orderShippingInformation: 'order.shippingInformation',
  orderPaidVia: 'order.paidVia',
  orderReceivingMethod: 'order.receivingMethod',
  orderStatus: 'order.status',
  orderPurchaseSummary: 'order.purchaseSummary',
  orderUniqueAssetId: 'order.uniqueAssetId',
  orderAssetName: 'order.assetName',
  orderTransactionStatus: 'order.transactionStatus',
  orderWalletAddressEdit: 'order.walletAddress.edit',
  orderWalletAddressNew: 'order.walletAddress.new',
  orderWalletAddressCurrent: 'order.walletAddress.current',

  redemptionDetailsPdf: 'redemption.details.pdf',
  
  redemptionAssetName: 'redemption.assetName',
  redemptionUniqueAssetId: 'redemption.uniqueAssetId',
  redemptionId: 'redemption.id',
  redemptionMethod: 'redemption.method',
  redemptionStatus: 'redemption.status',
  redemptionGross: 'redemption.gross',
  redemptionPayout: 'redemption.payout',
  redemptionType: 'redemption.type',

  redemptionSelectWalletHeader: 'redemption.selectWalletHeader',
  redemptionSelectWalletLabel: 'redemption.selectWalletLabel',
  redemptionWalletChangesWarning: 'redemption.walletChangesWarning',
  redemptionAnotherWallet: 'redemption.anotherWallet',
  redemptionChooseExistingWallet: 'redemption.chooseExistingWallet',

  redemptionSelectBankAccountHeader: 'redemption.selectBankAccountHeader',
  redemptionSelectBankAccountLabel: 'redemption.selectBankAccountLabel',
  redemptionBankAccountChangesWarning: 'redemption.bankAccountChangesWarning',
  redemptionAnotherBankAccount: 'redemption.anotherBankAccount',
  redemptionChooseExistingBankAccount: 'redemption.chooseExistingBankAccount',
  redemptionAddToMyBankAccounts: 'redemption.addToMyBankAccounts',

  redemptionBeneficiaryEnterDetails: "redemption.beneficiary.enterDetails",
  redemptionBeneficiaryInfo: "redemption.beneficiary.info",
  redemptionBeneficiaryAddress: "redemption.beneficiary.address",

  redemptionPayReceiveHeading: 'redemption.payReceive.heading',
  redemptionPayReceiveYouPay: 'redemption.payReceive.youPay',
  redemptionPayReceiveYouReceive: 'redemption.payReceive.youReceive',
  redemptionPayReceiveLimits: "redemption.payReceive.limits",
  redemptionPayReceiveStep: "redemption.payReceive.step",
  redemptionPayReceiveCountryChangeWarning: "redemption.payReceive.countryChangeWarning",
  redemptionPayReceiveRoundingWarning: "redemption.payReceive.roundingWarning",
  redemptionPayReceiveRoundingExplanation: "redemption.payReceive.roundingExplanation",
  redemptionPayReceiveRoundUp: "redemption.payReceive.roundUp",
  redemptionPayReceiveNetAmount: "redemption.payReceive.netAmount",
  redemptionPayReceiveTotalAmount: "redemption.payReceive.totalAmount",
  redemptionPayReceiveFees: "redemption.payReceive.fees",

  redemptionAdditionalDetailsTitle: "redemption.additionalDetails.title",

  redemptionAbort: 'redemption.abort',
  redemptionFeePercentage: "redemption.fee.percentage",
  redemptionFeeIssuer: "redemption.fee.issuer",
  redemptionFeeIssuerDescription: "redemption.fee.issuer.description",
  redemptionFeeMethodDescription: "redemption.fee.method.description",
  redemptionFeeCountryDescription: "redemption.fee.country.description",

  redeemHistoryHeader: 'redeemHistory.header',

  sidebarShop: 'sidebar.shop',
  sidebarRedemption: 'sidebar.redemption',
  sidebarKycCases: 'sidebar.kycCases',
  sidebarOrderManagement: 'sidebar.orderManagement',
  sidebarRedemptionManagement: 'sidebar.redemptionManagement',
  sidebarConfigManagement: 'sidebar.configManagement',
  sidebarJsonConfigManagement: 'sidebar.jsonConfigManagement',
  sidebarLoginRegister: 'sidebar.loginRegister',
  sidebarImprint: 'sidebar.imprint',
  sidebarKycReminder: 'sidebar.kycReminder',
  sidebarAndroid: 'sidebar.android',
  sidebarIOS: 'sidebar.iOS',
  sidebarLogoLink: 'sidebar.logoLink',
  sidebarLinks: 'sidebar.links',

  headerShop: 'header.shop',
  headerRedemption: 'header.redemption',
  headerKycCases: 'header.kycCases',
  headerOrderManagement: 'header.OrderManagement',
  headerRedemptionManagement: 'header.redemptionManagement',

  tableFilterPlaceholder: 'table.filter.placeholder',
  tableFilterSelectAll: 'table.filter.select.all',
  tablePaginationPage: 'table.pagination.page',
  tablePaginationGoToPage: 'table.pagination.goToPage',

  signupTitle: "signup.title",
  signupWelcome: "signup.welcome",
  signupCodeDescription: "signup.code.description",
  signupCodeLabel: "signup.code.label",
  signupCodePlaceholder: "signup.code.placeholder",
  signupEmailDescription: "signup.email.description",
  signupEmailCooldown: "signup.email.cooldown",
  signupEmailResend: "signup.email.resend",
  signupEmailConfirm: "signup.email.confirm",
  signupAdminTitle: "signup.admin.title",
  signupAdminDescription: "signup.admin.description",
  signupAdminStatus: "signup.admin.status",
  signupNotificationPurchase: "signup.notification.purchase",
  signupNotificationRedemption: "signup.notification.redemption",
  signupNotificationSidebar: "signup.notification.sidebar",
  signupNotificationSuccess: "signup.notification.success",
  signupBlockedTitle: "signup.blocked.title",
  signupBlockedDescription: "signup.blocked.description",

  validatorWalletAddressInvalid: 'validator.walletAddress.invalid',
  validatorWalletAddressRequired: 'validator.walletAddress.required',
  validatorKycTiersDescriptionTierRequired: 'validator.kycTiersDescription.tierRequired',
  validatorKycTiersDescriptionProviderRequired: 'validator.kycTiersDescription.providerRequired',
  validatorKycTiersDescriptionUniqueTierNumber: 'validator.kycTiersDescription.uniqueTierNumber',
  validatorKycTiersDescriptionSingleProvider: 'validator.kycTiersDescription.singleProvider',
  validatorIsFeaturedAssetSingleAsset: 'validator.isFeaturedAsset.singleAsset',
  validatorIsFeaturedAssetRequired: 'validator.isFeaturedAsset.required',
  validatorAssetsRequired: 'validator.assets.required',
  validatorAssetsUniqueAssetIds: 'validator.assets.uniqueAssetIds',
  validatorRedemption: "validator.redemption",
  validatorRedemptionUniqueMethodIds: 'validator.redemption.uniqueMethodIds',
  validatorRedemptionLimits: 'validator.redemption.limits',
  validatorRedemptionLimitsDuplicate: 'validator.redemption.limits.duplicate',
  validatorRedemptionLimitsScale: 'validator.redemption.limits.scale',
  validatorRedemptionMaxAmount: 'validator.redemption.maxAmount',
  validatorRedemptionFeesMissing: "validator.redemption.fees.missing",
  validatorRedemptionFeesInvalid: "validator.redemption.fees.invalid",
  validatorTranslationLanguageDefault: "validator.translation.language.default",
  validatorMessage: 'validator.message',
  validatorRelatedConflict: 'validator.related.conflict',
  validatorRelatedMissing: 'validator.related.missing',
  validatorOneOfMessage: 'validator.oneOf.message',
  validatorMaxLengthExceeded: 'validator.maxLengthExceeded',

  langAF: 'lang.AF',
  langAX: 'lang.AX',
  langAL: 'lang.AL',
  langDZ: 'lang.DZ',
  langAS: 'lang.AS',
  langAD: 'lang.AD',
  langAO: 'lang.AO',
  langAI: 'lang.AI',
  langAQ: 'lang.AQ',
  langAG: 'lang.AG',
  langAR: 'lang.AR',
  langAM: 'lang.AM',
  langAW: 'lang.AW',
  langAU: 'lang.AU',
  langAT: 'lang.AT',
  langAZ: 'lang.AZ',
  langBS: 'lang.BS',
  langBH: 'lang.BH',
  langBD: 'lang.BD',
  langBB: 'lang.BB',
  langBY: 'lang.BY',
  langBE: 'lang.BE',
  langBZ: 'lang.BZ',
  langBJ: 'lang.BJ',
  langBM: 'lang.BM',
  langBT: 'lang.BT',
  langBO: 'lang.BO',
  langBA: 'lang.BA',
  langBW: 'lang.BW',
  langBV: 'lang.BV',
  langBR: 'lang.BR',
  langIO: 'lang.IO',
  langBN: 'lang.BN',
  langBG: 'lang.BG',
  langBF: 'lang.BF',
  langBI: 'lang.BI',
  langKH: 'lang.KH',
  langCM: 'lang.CM',
  langCA: 'lang.CA',
  langCV: 'lang.CV',
  langKY: 'lang.KY',
  langCF: 'lang.CF',
  langTD: 'lang.TD',
  langCL: 'lang.CL',
  langCN: 'lang.CN',
  langCX: 'lang.CX',
  langCC: 'lang.CC',
  langCO: 'lang.CO',
  langKM: 'lang.KM',
  langCG: 'lang.CG',
  langCD: 'lang.CD',
  langCK: 'lang.CK',
  langCR: 'lang.CR',
  langCI: 'lang.CI',
  langHR: 'lang.HR',
  langCU: 'lang.CU',
  langCY: 'lang.CY',
  langCZ: 'lang.CZ',
  langDK: 'lang.DK',
  langDJ: 'lang.DJ',
  langDM: 'lang.DM',
  langDO: 'lang.DO',
  langEC: 'lang.EC',
  langEG: 'lang.EG',
  langSV: 'lang.SV',
  langGQ: 'lang.GQ',
  langER: 'lang.ER',
  langEE: 'lang.EE',
  langET: 'lang.ET',
  langFK: 'lang.FK',
  langFO: 'lang.FO',
  langFJ: 'lang.FJ',
  langFI: 'lang.FI',
  langFR: 'lang.FR',
  langGF: 'lang.GF',
  langPF: 'lang.PF',
  langTF: 'lang.TF',
  langGA: 'lang.GA',
  langGM: 'lang.GM',
  langGE: 'lang.GE',
  langDE: 'lang.DE',
  langGH: 'lang.GH',
  langGI: 'lang.GI',
  langGR: 'lang.GR',
  langGL: 'lang.GL',
  langGD: 'lang.GD',
  langGP: 'lang.GP',
  langGU: 'lang.GU',
  langGT: 'lang.GT',
  langGG: 'lang.GG',
  langGN: 'lang.GN',
  langGW: 'lang.GW',
  langGY: 'lang.GY',
  langHT: 'lang.HT',
  langHM: 'lang.HM',
  langVA: 'lang.VA',
  langHN: 'lang.HN',
  langHK: 'lang.HK',
  langHU: 'lang.HU',
  langIS: 'lang.IS',
  langIN: 'lang.IN',
  langID: 'lang.ID',
  langIR: 'lang.IR',
  langIQ: 'lang.IQ',
  langIE: 'lang.IE',
  langIM: 'lang.IM',
  langIL: 'lang.IL',
  langIT: 'lang.IT',
  langJM: 'lang.JM',
  langJP: 'lang.JP',
  langJE: 'lang.JE',
  langJO: 'lang.JO',
  langKZ: 'lang.KZ',
  langKE: 'lang.KE',
  langKI: 'lang.KI',
  langKR: 'lang.KR',
  langKP: 'lang.KP',
  langKW: 'lang.KW',
  langKG: 'lang.KG',
  langLA: 'lang.LA',
  langLV: 'lang.LV',
  langLB: 'lang.LB',
  langLS: 'lang.LS',
  langLR: 'lang.LR',
  langLY: 'lang.LY',
  langLI: 'lang.LI',
  langLT: 'lang.LT',
  langLU: 'lang.LU',
  langMO: 'lang.MO',
  langMK: 'lang.MK',
  langMG: 'lang.MG',
  langMW: 'lang.MW',
  langMY: 'lang.MY',
  langMV: 'lang.MV',
  langML: 'lang.ML',
  langMT: 'lang.MT',
  langMH: 'lang.MH',
  langMQ: 'lang.MQ',
  langMR: 'lang.MR',
  langMU: 'lang.MU',
  langYT: 'lang.YT',
  langMX: 'lang.MX',
  langFM: 'lang.FM',
  langMD: 'lang.MD',
  langMC: 'lang.MC',
  langMN: 'lang.MN',
  langME: 'lang.ME',
  langMS: 'lang.MS',
  langMA: 'lang.MA',
  langMZ: 'lang.MZ',
  langMM: 'lang.MM',
  langNA: 'lang.NA',
  langNR: 'lang.NR',
  langNP: 'lang.NP',
  langNL: 'lang.NL',
  langAN: 'lang.AN',
  langNC: 'lang.NC',
  langNZ: 'lang.NZ',
  langNI: 'lang.NI',
  langNE: 'lang.NE',
  langNG: 'lang.NG',
  langNU: 'lang.NU',
  langNF: 'lang.NF',
  langMP: 'lang.MP',
  langNO: 'lang.NO',
  langOM: 'lang.OM',
  langPK: 'lang.PK',
  langPW: 'lang.PW',
  langPS: 'lang.PS',
  langPA: 'lang.PA',
  langPG: 'lang.PG',
  langPY: 'lang.PY',
  langPE: 'lang.PE',
  langPH: 'lang.PH',
  langPN: 'lang.PN',
  langPL: 'lang.PL',
  langPT: 'lang.PT',
  langPR: 'lang.PR',
  langQA: 'lang.QA',
  langRE: 'lang.RE',
  langRO: 'lang.RO',
  langRU: 'lang.RU',
  langRW: 'lang.RW',
  langBL: 'lang.BL',
  langSH: 'lang.SH',
  langKN: 'lang.KN',
  langLC: 'lang.LC',
  langMF: 'lang.MF',
  langPM: 'lang.PM',
  langVC: 'lang.VC',
  langWS: 'lang.WS',
  langSM: 'lang.SM',
  langST: 'lang.ST',
  langSA: 'lang.SA',
  langSN: 'lang.SN',
  langRS: 'lang.RS',
  langSC: 'lang.SC',
  langSL: 'lang.SL',
  langSG: 'lang.SG',
  langSK: 'lang.SK',
  langSI: 'lang.SI',
  langSB: 'lang.SB',
  langSO: 'lang.SO',
  langZA: 'lang.ZA',
  langGS: 'lang.GS',
  langES: 'lang.ES',
  langLK: 'lang.LK',
  langSD: 'lang.SD',
  langSR: 'lang.SR',
  langSJ: 'lang.SJ',
  langSZ: 'lang.SZ',
  langSE: 'lang.SE',
  langCH: 'lang.CH',
  langSY: 'lang.SY',
  langTW: 'lang.TW',
  langTJ: 'lang.TJ',
  langTZ: 'lang.TZ',
  langTH: 'lang.TH',
  langTL: 'lang.TL',
  langTG: 'lang.TG',
  langTK: 'lang.TK',
  langTO: 'lang.TO',
  langTT: 'lang.TT',
  langTN: 'lang.TN',
  langTR: 'lang.TR',
  langTM: 'lang.TM',
  langTC: 'lang.TC',
  langTV: 'lang.TV',
  langUG: 'lang.UG',
  langUA: 'lang.UA',
  langAE: 'lang.AE',
  langGB: 'lang.GB',
  langUS: 'lang.US',
  langUM: 'lang.UM',
  langUY: 'lang.UY',
  langUZ: 'lang.UZ',
  langVU: 'lang.VU',
  langVE: 'lang.VE',
  langVN: 'lang.VN',
  langVG: 'lang.VG',
  langVI: 'lang.VI',
  langWF: 'lang.WF',
  langEH: 'lang.EH',
  langYE: 'lang.YE',
  langZM: 'lang.ZM',
  langZW: 'lang.ZW',

  commonSearchCodeUser: "admin:common.search.codeUser",
  commonSearchEmailUserId: "admin:common.search.emailUserId",
  configManagementHeader: 'admin:configManagement.header',
  configManagementPlaceholder: 'admin:configManagement.placeholder',
  configManagementMenuTenantConfiguration: 'admin:configManagement.menu.tenantConfiguration',
  configManagementMenuAvailableAssets: 'admin:configManagement.menu.availableAssets',
  configManagementMenuPurchaseConfiguration: 'admin:configManagement.menu.purchaseConfiguration',
  configManagementMenuRedemptionMethods: 'admin:configManagement.menu.redemptionMethods',
  configManagementMenuKyc: 'admin:configManagement.menu.kyc',
  featureToggleActivate: 'admin:featureToggle.activate',
  featureToggleDisable: 'admin:featureToggle.disable',
  featureToggleModalPurchaseFeatureName: 'admin:featureToggleModal.purchase.featureName',
  featureToggleModalPurchaseActivateText: 'admin:featureToggleModal.purchase.activateText',
  featureToggleModalPurchaseDisableText: 'admin:featureToggleModal.purchase.disableText',
  featureToggleModalRedeemFeatureName: 'admin:featureToggleModal.redeem.featureName',
  featureToggleModalRedeemActivateText: 'admin:featureToggleModal.redeem.activateText',
  featureToggleModalRedeemDisableText: 'admin:featureToggleModal.redeem.disableText',
  featureToggleModalKycFeatureName: 'admin:featureToggleModal.kyc.featureName',
  featureToggleModalKycActivateText: 'admin:featureToggleModal.kyc.activateText',
  featureToggleModalKycDisableText: 'admin:featureToggleModal.kyc.disableText',
  featureToggleModalCustomPurchaseFeatureName: 'admin:featureToggleModal.customPurchase.featureName',
  featureToggleModalCustomPurchaseActivateText: 'admin:featureToggleModal.customPurchase.activateText',
  featureToggleModalCustomPurchaseDisableText: 'admin:featureToggleModal.customPurchase.disableText',
  kycManagementRecordInformationHeader: 'admin:kycManagement.recordInformation.header',
  kycManagementRecordInformationProvider: 'admin:kycManagement.recordInformation.provider',
  kycManagementRecordInformationPhoto: 'admin:kycManagement.recordInformation.photo',
  kycManagementRecordInformationResidence: 'admin:kycManagement.recordInformation.residence',
  kycManagementRecordInformationStatus: 'admin:kycManagement.recordInformation.status',
  kycManagementUserInformationTierLabel: 'admin:kycManagement.userInformation.tierLabel',
  kycManagementDetailsOpen: 'admin:kycManagement.details.open',
  kycManagementDetailsApproved: 'admin:kycManagement.details.approved',
  kycManagementDetailsDeclined: 'admin:kycManagement.details.declined',
  kycManagementDetailsDropdownOpen: 'admin:kycManagement.details.dropdown.open',
  kycManagementDetailsDropdownApproved: 'admin:kycManagement.details.dropdown.approved',
  kycManagementDetailsDropdownDeclined: 'admin:kycManagement.details.dropdown.declined',
  kycManagementDetailsHeader: 'admin:kycManagement.details.header',
  kycManagementDetailsKycHistory: 'admin:kycManagement.details.kycHistory',
  kycManagementDetailsStatusUpdateDate: 'admin:kycManagement.details.statusUpdateDate',
  kycManagementDetailsRequestStatus: 'admin:kycManagement.details.requestStatus',
  kycManagementDetailsCaseStatus: 'admin:kycManagement.details.caseStatus',
  kycManagementDetailsOpenDate: 'admin:kycManagement.details.openDate',
  kycManagementDetailsCompletionDate: 'admin:kycManagement.details.completionDate',
  kycManagementDetailsProviderResponse: 'admin:kycManagement.details.providerResponse',
  kycManagementDetailsAdminReason: 'admin:kycManagement.details.adminReason',
  kycManagementDetailsReadResponse: 'admin:kycManagement.details.readResponse',
  kycManagementDetailsReadFullReason: 'admin:kycManagement.details.readFullReason',
  kycManagementDetailsDeclineTitle: 'admin:kycManagement.details.declineTitle',
  kycManagementDetailsProviderTierAtStart: 'admin:kycManagement.details.tierAtStart',
  kycManagementDetailsProviderRequestedTier: 'admin:kycManagement.details.requestedTier',
  kycManagementDetailsTableId: 'admin:kycManagement.details.table.id',
  kycManagementDetailsTableOpenDate: 'admin:kycManagement.details.table.openDate',
  kycManagementDetailsTableCompletionDate: 'admin:kycManagement.details.table.completionDate',
  kycManagementDetailsTableCaseStatus: 'admin:kycManagement.details.table.caseStatus',
  kycManagementOverviewSearchByUser: 'admin:kycManagement.overview.searchByUser',
  kycManagementOverviewId: 'admin:kycManagement.overview.id',
  kycManagementOverviewUser: 'admin:kycManagement.overview.user',
  kycManagementOverviewOpenCompletionDate: 'admin:kycManagement.overview.openCompletionDate',
  kycManagementOverviewCaseStatus: 'admin:kycManagement.overview.caseStatus',
  kycManagementOverviewRequestStatus: 'admin:kycManagement.overview.requestStatus',
  kycManagementOverviewUpdated: 'admin:kycManagement.overview.updated',
  kycManagementStatusSettings: 'admin:kycManagement.statusSettings',
  kycManagementAutoApproveTitle: 'admin:kycManagement.autoApprove.title',
  kycManagementAutoApproveDescription: 'admin:kycManagement.autoApprove.description',
  kycManagementAutoDeclineTitle: 'admin:kycManagement.autoDecline.title',
  kycManagementAutoDeclineDescription: 'admin:kycManagement.autoDecline.description',
  kycManagementAutoEnable: 'admin:kycManagement.auto.enable',
  kycManagementAutoDisable: 'admin:kycManagement.auto.disable',
  purchaseConfigurationAssetsForPurchasingTitle: 'admin:purchaseConfiguration.assetsForPurchasing.title',
  purchaseConfigurationPaymentConfigurationsTitle: 'admin:purchaseConfiguration.paymentConfigurations.title',
  purchaseManagementDetailsSendConfirmationMessage:
    'admin:purchaseManagement.details.send.confirmationMessage',
  purchaseManagementDetailsSendConfirmationTitle:
    'admin:purchaseManagement.details.send.confirmationTitle',
  redeemManagementDetailsHeader: 'admin:redeemManagement.details.header',
  redeemManagementDetailsRequestInformationHeader:
    'admin:redeemManagement.details.requestInformation.header',
  redeemManagementDetailsRequestInformationGrossAmount:
    'admin:redeemManagement.details.requestInformation.amountToPay',
  redeemManagementDetailsRequestInformationNetAmount:
    'admin:redeemManagement.details.requestInformation.netAmount',
  redeemManagementDetailsRequestInformationNetAmountValue:
    'admin:redeemManagement.details.requestInformation.netAmountValue',
  redeemManagementDetailsRedemptionRequestHeader:
    'admin:redeemManagement.details.redemptionRequest.header',
  redeemManagementDetailsRedemptionRequestShowFees:
    'admin:redeemManagement.details.redemptionRequest.showFees',
  redeemManagementDetailsRedemptionRequestHideFees:
    'admin:redeemManagement.details.redemptionRequest.hideFees',
  shuftiProRequestReceived: 'admin:shuftiPro.RequestReceived',
  shuftiProRequestPending: 'admin:shuftiPro.RequestPending',
  shuftiProRequestTimeout: 'admin:shuftiPro.RequestTimeout',
  shuftiProVerificationCancelled: 'admin:shuftiPro.VerificationCancelled',
  shuftiProVerificationAccepted: 'admin:shuftiPro.VerificationAccepted',
  shuftiProVerificationDeclined: 'admin:shuftiPro.VerificationDeclined',
  shuftiProVerificationError: 'admin:shuftiPro.VerificationError',
  tenantSettingsGeneralSettingsTitle: 'admin:tenantSettings.generalSettings.title',
  tenantSettingsLanguagesAndCurrenciesTitle:
    'admin:tenantSettings.languagesAndCurrencies.title',
  tenantSettingsBrandingSettingsTitle: 'admin:tenantSettings.brandingSettings.title',
  tenantSettingsFeaturesMain: 'admin:tenantSettings.features.main',
  tenantSettingsFeaturesAdditional: 'admin:tenantSettings.features.additional',
  tenantSettingsFeaturesPurchaseTitle: 'admin:tenantSettings.features.purchase.title',
  tenantSettingsFeaturesPurchaseDescription:
    'admin:tenantSettings.features.purchase.description',
  tenantSettingsFeaturesPurchaseTooltip:
    'admin:tenantSettings.features.purchase.tooltip',
  tenantSettingsFeaturesRedeemTitle: 'admin:tenantSettings.features.redeem.title',
  tenantSettingsFeaturesRedeemDescription:
    'admin:tenantSettings.features.redeem.description',
  tenantSettingsFeaturesKycTitle: 'admin:tenantSettings.features.kyc.title',
  tenantSettingsFeaturesKycDescription:
    'admin:tenantSettings.features.kyc.description',
  tenantSettingsFeaturesCustomPurchaseTitle:
    'admin:tenantSettings.features.customPurchase.title',
  tenantSettingsFeaturesCustomPurchaseDescription:
    'admin:tenantSettings.features.customPurchase.description',
  tenantSettingsFeaturesRestrictedModeTitle:
    'admin:tenantSettings.features.restrictedMode.title',
  tenantSettingsFeaturesRestrictedModeDescription:
    'admin:tenantSettings.features.restrictedMode.description',
  tenantSettingsFeaturesRestrictedModeEnableTitle:
    'admin:tenantSettings.features.restrictedMode.enable.title',
  tenantSettingsFeaturesRestrictedModeEnableDescription:
    'admin:tenantSettings.features.restrictedMode.enable.description',
  tenantSettingsFeaturesRestrictedModeDisableTitle:
    'admin:tenantSettings.features.restrictedMode.disable.title',
  tenantSettingsFeaturesRestrictedModeDisableDescription:
    'admin:tenantSettings.features.restrictedMode.disable.description',
  tenantSettingsFeaturesAuthButton: 'admin:tenantSettings.features.authButton',
  tenantSettingsMobileTitle: 'admin:tenantSettings.mobile.title',
  tenantSettingsMobileDescription: 'admin:tenantSettings.mobile.description',
  tenantSettingsMobileInputLabel: 'admin:tenantSettings.mobile.input.label',
  tenantSettingsAdminTableHeading: 'admin:tenantSettings.admin.table.heading',
  tenantSettingsAdminTableTooltip: 'admin:tenantSettings.admin.table.tooltip',
  tenantSettingsAdminTableAdd: 'admin:tenantSettings.admin.table.add',
  tenantSettingsAdminTableAddDescription:
    'admin:tenantSettings.admin.table.add.description',
  tenantSettingsAdminTableSearchUser: 'admin:tenantSettings.admin.table.searchUser',
  tenantSettingsAdminTableSelectionAmount:
    'admin:tenantSettings.admin.table.selectionAmount',
  tenantSettingsAdminTableRemove: 'admin:tenantSettings.admin.table.remove',
  tenantSettingsAdminTableRemoveConfirmation:
    'admin:tenantSettings.admin.table.remove.confirmation',
  tenantSettingsAdminTableRemoveInfo: 'admin:tenantSettings.admin.table.remove.info',
  tenantSettingsLanguagesAvailableTitle: "admin:tenantSettings.languages.available.title",
  tenantSettingsLanguagesAvailableTooltip: "admin:tenantSettings.languages.available.tooltip",
  tenantSettingsLanguagesDefaultSelect: "admin:tenantSettings.languages.default.select",
  tenantSettingsLanguagesDefaultTooltip: "admin:tenantSettings.languages.default.tooltip",
  tenantSettingsLanguagesDefaultModalTitle: "admin:tenantSettings.languages.default.modal.title",
  tenantSettingsLanguagesDefaultModalDescription: "admin:tenantSettings.languages.default.modal.description",
  tenantSettingsCurrencySelect: "admin:tenantSettings.currency.select",
  tenantSettingsCurrencyTooltip: "admin:tenantSettings.currency.tooltip",
  tenantSettingsCurrencyPlaceholder: "admin:tenantSettings.currency.placeholder",
  tenantSettingsEmailNotificationsHeading: "admin:tenantSettings.emailNotifications.heading",
  tenantSettingsEmailNotificationsSubheading: "admin:tenantSettings.emailNotifications.subheading",
  tenantSettingsEmailNotificationsTooltip: "admin:tenantSettings.emailNotifications.tooltip",
  tenantSettingsEmailNotificationsError: "admin:tenantSettings.emailNotifications.error",
  configConfigure: 'admin:config.configure',
  configSaveSettings: 'admin:config.saveSettings',
  configUpdateSettings: 'admin:config.updateSettings',
  configEnableMethod: 'admin:config.enableMethod',
  configDisableMethod: 'admin:config.disableMethod',
  configDisableFeature: 'admin:config.disableFeature',

  configPurchaseNotification: 'admin:config.purchase.notification',
  configPurchaseDisableTitle: 'admin:config.purchase.disable.title',
  configPurchaseDisableText: 'admin:config.purchase.disable.text',
  configPurchaseFooterTitle: 'admin:config.purchase.footer.title',
  configPurchaseFooterDescription: 'admin:config.purchase.footer.description',
  configPurchaseFooterTooltip: 'admin:config.purchase.footer.tooltip',
  configPurchaseFooterEnableButton: 'admin:config.purchase.footer.enable.button',
  configPurchaseFooterEnableTooltip: 'admin:config.purchase.footer.enable.tooltip',

  configCollectionMethod: 'admin:config.collection.method',
  configCollectionTitle: 'admin:config.collection.title',
  configCollectionDescription: 'admin:config.collection.description',
  configCollectionTooltip: 'admin:config.collection.tooltip',
  configCollectionTranslationDescriptionTitle: 'admin:config.collection.translation.description.title',
  configCollectionTranslationDescriptionPlaceholder: 'admin:config.collection.translation.description.placeholder',
  configCollectionTranslationDescriptionTooltip: 'admin:config.collection.translation.description.tooltip',
  configCollectionTranslationDisclaimerTitle: 'admin:config.collection.translation.disclaimer.title',
  configCollectionTranslationDisclaimerPlaceholder: 'admin:config.collection.translation.disclaimer.placeholder',
  configCollectionTranslationDisclaimerTooltip: 'admin:config.collection.translation.disclaimer.tooltip',
  configCollectionWlmWalletsLabel: 'admin:config.collection.wlmWallets.label',
  configCollectionWlmWalletsTooltip: 'admin:config.collection.wlmWallets.tooltip',
  configCollectionSerialNumberRegexTitle: 'admin:config.collection.serialNumberRegex.title',
  configCollectionSerialNumberRegexTooltip: 'admin:config.collection.serialNumberRegex.tooltip',
  configCollectionSerialNumberRegexLabel: 'admin:config.collection.serialNumberRegex.label',
  configCollectionSerialNumberRegexError: 'admin:config.collection.serialNumberRegex.error',
  
  configCollectionFeesTitle: 'admin:config.collection.fees.title',
  configCollectionFeesSubtitle: 'admin:config.collection.fees.subtitle',
  configCollectionFeesDescription: 'admin:config.collection.fees.description',
  configCollectionFeesExampleDescription: 'admin:config.collection.fees.example.description',
  configCollectionFeesExampleVariable: 'admin:config.collection.fees.example.variable',
  configCollectionFeesExampleFixed: 'admin:config.collection.fees.example.fixed',
  configCollectionFeesExampleTotalAmount: 'admin:config.collection.fees.example.total.amount',
  configCollectionFeesExampleTotalDescription: 'admin:config.collection.fees.example.total.description',
  configCollectionFeesMethodTitle: 'admin:config.collection.fees.method.title',
  configCollectionFeesMethodDescription: 'admin:config.collection.fees.method.description',
  configCollectionFeesMethodFixed: 'admin:config.collection.fees.method.fixed',
  configCollectionFeesMethodVariable: 'admin:config.collection.fees.method.variable',
  configCollectionFeesCountryTitle: 'admin:config.collection.fees.country.title',
  configCollectionFeesCountryDescription: 'admin:config.collection.fees.country.description',
  configCollectionFeesCountrySubtitle: 'admin:config.collection.fees.country.subtitle',
  configCollectionFeesCountryFixed: 'admin:config.collection.fees.country.fixed',
  configCollectionFeesCountryVariable: 'admin:config.collection.fees.country.variable',
  configCollectionFeesCountryDefaultTitle: 'admin:config.collection.fees.country.default.title',
  configCollectionFeesCountryDefaultFixed: 'admin:config.collection.fees.country.default.fixed',
  configCollectionFeesCountryDefaultVariable: 'admin:config.collection.fees.country.default.variable',
  configCollectionFeesCountryButton: 'admin:config.collection.fees.country.button',
  configCollectionFooterDescription: 'admin:config.collection.footer.description',

  configPaymentMethod: 'admin:config.payment.method',
  configPaymentTitle: 'admin:config.payment.title',
  configPaymentDescription: 'admin:config.payment.description',
  configPaymentTooltip: 'admin:config.payment.tooltip',
  configPaymentApiKey: 'admin:config.payment.api.key',
  configPaymentApiSecret: 'admin:config.payment.api.secret',

  configPaymentBankTransferTranslationBeneficiaryLabel: 'admin:config.payment.bankTransfer.translation.beneficiary.label',
  configPaymentBankTransferBeneficiaryTitle: 'admin:config.payment.bankTransfer.beneficiary.title',
  configPaymentBankTransferBeneficiaryTooltip: 'admin:config.payment.bankTransfer.beneficiary.tooltip',
  configPaymentBankTransferBeneficiaryName: 'admin:config.payment.bankTransfer.beneficiary.name',
  configPaymentBankTransferBeneficiaryNameTooltip: 'admin:config.payment.bankTransfer.beneficiary.name.tooltip',
  configPaymentBankTransferAccountTooltip: 'admin:config.payment.bankTransfer.account.tooltip',
  configPaymentBankTransferAddressTooltip: 'admin:config.payment.bankTransfer.address.tooltip',
  configPaymentBankTransferNameTooltip: 'admin:config.payment.bankTransfer.name.tooltip',
  configPaymentBankTransferSwiftTooltip: 'admin:config.payment.bankTransfer.swift.tooltip',
  configPaymentBankTransferBicTooltip: 'admin:config.payment.bankTransfer.bic.tooltip',
  configPaymentBankTransferIntermediaryDescription: 'admin:config.payment.bankTransfer.intermediary.description',
  configPaymentBankTransferIntermediaryTooltip: 'admin:config.payment.bankTransfer.intermediary.tooltip',
  configPaymentBankTransferIntermediaryTranslationTitle: 'admin:config.payment.bankTransfer.intermediary.translation.title',
  configPaymentBankTransferIntermediaryTranslationTooltip: 'admin:config.payment.bankTransfer.intermediary.translation.tooltip',
  configPaymentBankTransferIdentifiersTitle: 'admin:config.payment.bankTransfer.identifiers.title',
  configPaymentBankTransferIdentifiersDescription: 'admin:config.payment.bankTransfer.identifiers.description',
  configPaymentBankTransferIdentifiersAdd: 'admin:config.payment.bankTransfer.identifiers.add',
  configPaymentBankTransferIdentifiersConfirmation: 'admin:config.payment.bankTransfer.identifiers.confirmation',
  configPaymentBankTransferIdentifiersLabelValue: 'admin:config.payment.bankTransfer.identifiers.label.value',
  configPaymentBankTransferIdentifiersLabelNameDefault: 'admin:config.payment.bankTransfer.identifiers.label.name.default',
  configPaymentBankTransferIdentifiersLabelNameLanguage: 'admin:config.payment.bankTransfer.identifiers.label.name.language',
  configPaymentBankTransferIdentifiersLabelDescriptionDefault: 'admin:config.payment.bankTransfer.identifiers.label.description.default',
  configPaymentBankTransferIdentifiersLabelDescriptionLanguage: 'admin:config.payment.bankTransfer.identifiers.label.description.language',

  configPaymentCreditCardAccountTitle: 'admin:config.payment.creditCard.account.title',
  configPaymentCreditCardAccountName: 'admin:config.payment.creditCard.account.name',
  configPaymentCreditCardAccountNameDescription: 'admin:config.payment.creditCard.account.name.description',
  configPaymentCreditCardAccountKeyDescription: 'admin:config.payment.creditCard.account.key.description',
  configPaymentCreditCardAccountInvalid: 'admin:config.payment.creditCard.account.invalid',

  configPaymentCryptoCurrencyAccountTitle: 'admin:config.payment.cryptoCurrency.account.title',
  configPaymentCryptoCurrencyAccountDescription: 'admin:config.payment.cryptoCurrency.account.description',
  configPaymentCryptoCurrencyAccountKeyDescription: 'admin:config.payment.cryptoCurrency.account.key.description',
  configPaymentCryptoCurrencyAccountInvalid: 'admin:config.payment.cryptoCurrency.account.invalid',

  configPaymentTranslationDescriptionTitle: 'admin:config.payment.translation.description.title',
  configPaymentTranslationDescriptionTooltip: 'admin:config.payment.translation.description.tooltip',
  configPaymentTranslationDescriptionPlaceholder: 'admin:config.payment.translation.description.placeholder',
  configPaymentFooterDescription: 'admin:config.payment.footer.description',

  configPaymentKycTitle: 'admin:config.payment.kyc.title',
  configPaymentKycTooltip: 'admin:config.payment.kyc.toolip',
  configPaymentKycLabel: 'admin:config.payment.kyc.label',

  configPaymentLimitTitle: 'admin:config.payment.limit.title',
  configPaymentLimitTooltip: 'admin:config.payment.limit.toolip',
  configPaymentLimitLabel: 'admin:config.payment.limit.label',

  configPaymentTemplateHeading: 'admin:config.payment.template.heading',
  configPaymentTemplateDescription: 'admin:config.payment.template.description',
  configPaymentTemplateRequirement: 'admin:config.payment.template.requirement',
  configPaymentTemplateRules: 'admin:config.payment.template.rules',
  configPaymentTemplateTest: 'admin:config.payment.template.test',

  configRedemptionTitle: 'admin:config.redemption.title',
  configRedemptionDescription: 'admin:config.redemption.description',
  configRedemptionTemplateHeading: 'admin:config.redemption.template.heading',
  configRedemptionTemplateRules: 'admin:config.redemption.template.rules',
  configRedemptionButton: 'admin:config.redemption.button',

  configFooterMethodEnabledDescription: 'admin:config.footer.method.enabled.description',

  configTemplatesRequirementsHeading: 'admin:config.templates.requirements.heading',
  configTemplatesRequirement: 'admin:config.templates.requirement',
  configTemplatesError: 'admin:config.templates.error',
  configTemplatesUpload: 'admin:config.templates.upload',

  configTranslationsField: 'admin:config.translations.field',
  configTranslationsTitle: 'admin:config.translations.title',
  configTranslationsDescriptionLabelDefault: 'admin:config.translations.description.label.default',
  configTranslationsDescriptionLabelLanguage: 'admin:config.translations.description.label.language',
  configTranslationsDisclaimerLabelDefault: 'admin:config.translations.disclaimer.label.default',
  configTranslationsDisclaimerLabelLanguage: 'admin:config.translations.disclaimer.label.language',
  configTranslationsLanguageLabel: 'admin:config.translations.language.label',
  configTranslationsLanguageButton: 'admin:config.translations.language.button',

  adminLanguage: "admin:language"
};

export { i18nextKeys };
